import React, { useState,useEffect } from 'react';
import ReactDOM from 'react-dom';
import Sidebar from '../Sidebar/Sidebar';
import $, { data } from 'jquery';
import { useNavigate } from 'react-router-dom';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

const AddCv = () => {

    const [title, setTitle] = useState("");

  const handleSubmit = () => {
    console.log("CV Title Submitted:", title);
  };
    
  return (
    
    <div className="container-fluid">
      
    <div className="row ">
      <Sidebar />
      <main className="col-md-9 ms-sm-auto col-lg-9 px-md- mb-4 mt-4">
      <div id="loading">
  <div class="loader">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <div class="loader-text">Loading...</div>
  </div>
</div>
<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2>Add CV</h2>
      </div>
      <div style={{ width: '100%', background: '#f8f8f8', padding: '20px', borderRadius: '10px', marginTop: '20px' }}>
        <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px' }}>
          Title<span style={{ color: 'red' }}>*</span>
        </label>
        <input
          type="text"
          placeholder="Profile Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', marginBottom: '20px' }}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button style={{ background: '#E0E0E0', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer' }}>CANCEL</button>
          <button style={{ background: '#5A67D8', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer' }} onClick={handleSubmit}>SUBMIT</button>
        </div>
      </div>
    </div>
      
  </main>
    </div>
  </div>
  );
};

export default AddCv;
